import { combineReducers } from 'redux';
import mediaReducer from './store/mediaReducer';

export const reducers = combineReducers({
    media: mediaReducer
});